import apiClient from "./client";
import type {
  GrowSignalsResponse,
  SetGrowSignalRequest,
  GrowSignal,
} from "@/types/api";

/** Sinais clean-core do GROW recomendados + status por projeto (S-043.7). */
export async function getGrowSignals(projectId: string): Promise<GrowSignalsResponse> {
  const res = await apiClient.get<GrowSignalsResponse>(
    `/api/projects/${projectId}/grow-signals`,
  );
  return res.data;
}

export async function setGrowSignal(
  projectId: string,
  scenarioId: string,
  data: SetGrowSignalRequest,
): Promise<GrowSignal> {
  const res = await apiClient.put<GrowSignal>(
    `/api/projects/${projectId}/grow-signals/${scenarioId}`,
    data,
  );
  return res.data;
}

/** Verifica ao vivo se o cenário está ativo no GROW; só então marca Activated. */
export async function verifyGrowSignal(
  projectId: string,
  scenarioId: string,
  servicePath: string,
): Promise<{ verified: boolean; status: string; message: string }> {
  const res = await apiClient.post(
    `/api/projects/${projectId}/grow-signals/${scenarioId}/verify`,
    { service_path: servicePath },
  );
  return res.data;
}
